import {getNewsList,getNewsDetail} from '@/api/newsCenter.js';

const state = {
   total:0,
   newsList:[],
   newsDetail:{}


}
const mutations = {
    GETNEWSLIST(state,value){
        state.total = value.total
        state.newsList = value.records
        // console.log(value,123)
    },
    GETNEWSDETAIL(state,value){
        state.newsDetail = value
        // console.log(value,123)
    }
}
const actions = {
    async getNewsList({commit},value){
        let res = await getNewsList(value.pageNum,value.pageSize,value.type)
        if(res.code == 200){
            // console.log(res,966)
            commit('GETNEWSLIST',res.data)
        }else{
        //    console.log(res,msg)
            // new Error(res.msg)
        }
    },

    async getNewsDetail({commit},id){
        let res = await getNewsDetail(id)
        if(res.code == 200){
            // console.log(res)
            commit('GETNEWSDETAIL',res.data)
        }else{
            // console.log(res,msg)
            // new Error(res.msg)
        }
    }
}
const getters = {}

export default{
    namespaced:true,
    state,
    mutations,
    actions,  //之前写成了action
    getters
}